import React from 'react';
import PropTypes from 'prop-types';

import ProductPropertyTab, { PropertyList } from '../../molecules/product-detail-accordion';

const KeyIngredientsBenefits = ({ product, ingredients }) => {
  if (!ingredients || ingredients.length === 0) return null;

  const parsedIngredients = ingredients.reduce((acc, curr) => {
    const { value } = curr;

    try {
      // no validation that there isn't more than one colon
      const [key, ...rest] = value.split(':');
      acc.push([key, rest.join().trim()]);
    } catch (error) {
      acc.push([false, value]);
    }

    return acc;
  }, []);

  return (parsedIngredients && parsedIngredients.length > 0) ? (
    <ProductPropertyTab title="Key ingredients & Benefits" product={product}>
      <PropertyList element="ul" like="dec-4">
        {
          parsedIngredients.map(([key, value]) => (
            <li key={key || value}>
              {
                key
                  ? <b>{`${key}: `}</b>
                  : ''
              }
              {value}
            </li>
          ))
        }
      </PropertyList>
    </ProductPropertyTab>
  ) : null;
};

KeyIngredientsBenefits.defaultProps = {
  ingredients: []
};

KeyIngredientsBenefits.propTypes = {
  product: PropTypes.object.isRequired,
  ingredients: PropTypes.array
};

export default KeyIngredientsBenefits;
